import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/storage";

//add Firebase config here
const config = {
  apiKey: "AIzaSyC3xwl8vvJx4fhopvLbZyudJijKMgPzWPk",
  authDomain: "viral-kindness.firebaseapp.com",
  projectId: "viral-kindness",
  storageBucket: "viral-kindness.appspot.com",
  messagingSenderId: "351070048723",
  appId: "1:351070048723:web:449213cd41d3e9f84b1f26",
  measurementId: "G-D5RBV6CC6N"
};

firebase.initializeApp(config);

firebase.analytics();
Vue.prototype.$analytics = firebase.analytics();

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();

export { db, auth, firebase };
